export const limitArray = <T>(array: T[], limit = 30) => {
  if (array.length > limit) {
    return array.slice(0, limit)
  }
  return array
}
